import { useEffect } from "react";

import { $api } from "@/shared/api";

// Отметить, что игрок открыл готовый разбор (`POST /api/analyses/{id}/viewed`) — для дашборда
// команды: сколько разборов читают. Раз на разбор за показ экрана; повтор сервер не считает,
// ответ и ошибка экрану не нужны.
export const useMarkAnalysisViewed = (analysisId: number): void => {
  const { mutate } = $api.useMutation("post", "/api/analyses/{analysis_id}/viewed");
  useEffect(() => {
    mutate({ params: { path: { analysis_id: analysisId } } });
  }, [analysisId, mutate]);
};
